import { Injectable } from '@angular/core';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { LightsSettingsSupportType } from '@shure/shared/angular/features/device-lights-settings/data-access';
import {
	LightsImage,
	LightsImageProvider
} from '@shure/shared/angular/features/device-lights-settings/feature-device-image-next';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

@Injectable()
export class Mxa901CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin implements LightsImageProvider {
	public override readonly models: DeviceModel[] = [DeviceModel.MXA901R, DeviceModel.MXA901S];

	public override getLightsSettingsSupportType(): LightsSettingsSupportType {
		return LightsSettingsSupportType.Supported;
	}

	public getLightsImage(model: DeviceModel): LightsImage {
		return {
			imageUrl: `device-mxa9xx-${model === DeviceModel.MXA901S ? 's' : 'r'}.svg`
		};
	}
}
